import { useLocalStorage } from '@rehooks/local-storage';

import useSelector from '@app/hooks/useSelector';
import { getProject } from '@app/selectors';

const useMarketingSupportProjectSelectedAppSlug = () => {
    const { id } = useSelector(getProject);

    const [marketingSupportProjectSelectedAppSlug, setMarketingSupportProjectSelectedAppSlug] = useLocalStorage(
        `marketing-support-${id}`,
        '',
    );

    return { marketingSupportProjectSelectedAppSlug, setMarketingSupportProjectSelectedAppSlug };
};

export default useMarketingSupportProjectSelectedAppSlug;
